// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get, isEmpty} from 'lodash';

// Relative Imports
import basicInfoActions from '../../actions/basicInformation';
import appActions from '../../actions/actions';
import BasicInformation from './BasicInformation';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        enableContinueButton: get(state, 'basicInformation.enableContinueButton', false),
        firstName: get(state, 'basicInformation.firstName', ''),
        lastName: get(state, 'basicInformation.lastName', ''),
        email: get(state, 'basicInformation.email', ''),
        firstNameError: get(state, 'basicInformation.firstNameError', ''),
        lastNameError: get(state, 'basicInformation.lastNameError', ''),
        emailError: get(state, 'basicInformation.emailError', ''),
        brandSwitchParams: get(state, 'app.brandSwitchParams', {}),
        dyff: get(state,'app.dyff', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        basicInfoActions: bindActionCreators(basicInfoActions, dispatch),
        appActions: bindActionCreators(appActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class BasicInformationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.setFirstName = this.setFirstName.bind(this);
        this.setLastName = this.setLastName.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.onEmailBlur = this.onEmailBlur.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(false);
    }

    componentDidMount() {
        const {brandSwitchParams, dyff} = this.props;
        if (!isEmpty(brandSwitchParams) && !dyff?.HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
            this.props.basicInfoActions.prePopulateBasicInfo(brandSwitchParams);
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Basic Information Page');
    }

    triggerEdapEventOnFocus(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Focus on input field:${event.target.name}`
        }, {});
    }

    setFirstName(event) {
        event.preventDefault();
        this.setFieldsError(event.target.id);
        this.props.basicInfoActions.setFirstName(event.target.value);
        this.props.basicInfoActions.toggleContinueButton();
    }

    setLastName(event) {
        event.preventDefault();
        this.setFieldsError(event.target.id);
        this.props.basicInfoActions.setLastName(event.target.value);
        this.props.basicInfoActions.toggleContinueButton();
    }

    setEmail(event) {
        event.preventDefault();
        this.setFieldsError(event.target.id);
        this.props.basicInfoActions.setEmail(event.target.value);
        this.props.basicInfoActions.toggleContinueButton();
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.basicInfoActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    onEmailBlur(event) {
        event.preventDefault();
        this.props.basicInfoActions.validateEmail(this.props.email);
    }

    setFieldsError(errorField) {
        const fields = [
            'firstName',
            'lastName',
            'email'
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.basicInfoActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'firstName' && !this.props.firstName.trim())
                || (fieldVal === 'lastName' && !this.props.lastName.trim())
                || (fieldVal === 'email' && !this.props.email.trim())) {
                this.props.basicInfoActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});

        if (this.props.dyff?.HANDLE_SSO_LANGUAGE_CURRENCY_MISMATCH) {
            this.props.appActions.changeAppState('COMPANY_LOCATION');
        } else if (isEmpty(this.props.brandSwitchParams)) {
            this.props.appActions.changeAppState('SUPPORTED_CURRENCY');
        } else {
            this.props.appActions.changeAppState('COMPANY_LOCATION');
        }
    }

    render() {
        return (<div>
            <BasicInformation
                translations = {this.props.translations}

                firstNameError = {this.props.firstNameError}
                firstNameVal = {this.props.firstName}
                handleFirstNameChange = {this.setFirstName}

                lastNameError = {this.props.lastNameError}
                lastNameVal = {this.props.lastName}
                handleLastNameChange = {this.setLastName}

                emailError = {this.props.emailError}
                emailVal = {this.props.email}
                handleEmailChange = {this.setEmail}
                handleFirstNameBlur = {this.showOnFieldBlur}
                handleLastNameBlur = {this.showOnFieldBlur}
                handleEmailBlur = {this.onEmailBlur}

                handleFormSubmit = {this.handleFormSubmit}
                enableContinueButton={this.props.enableContinueButton}

                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                triggerEdapEventOnFocus = {this.triggerEdapEventOnFocus}
            />
        </div>);
    }
}

BasicInformationContainer.propTypes = {
    firstName: PropTypes.string,
    firstNameError: PropTypes.string,

    lastName: PropTypes.string,
    lastNameError: PropTypes.string,

    email: PropTypes.string,
    emailError: PropTypes.string,

    enableContinueButton: PropTypes.bool,

    publicUuid: PropTypes.string
};

BasicInformationContainer.defaultProps = {
    firstName: '',
    firstNameError: '',

    lastName: '',
    lastNameError: '',

    email: '',
    emailError: '',

    enableContinueButton: false,

    publicUuid: '-1'
};

export default BasicInformationContainer;
